export default "__VITE_ASSET__pNmO5fC9__"